import React from "react";

import Sidebar from "./Sidebar";
import Visuals from "./Visuals";

function Home() {
  return (
    <div className="">
      <Sidebar />
      <Visuals />
    </div>
  );
}

export default Home;
